import axios from 'axios';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TablePagination,
  TextField,
} from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import React, { useEffect, useState } from 'react';

import { toast } from 'react-toastify';

import { DeleteButton, EditButton } from '@src/components/buttons';
import ButtonAction from '@src/components/buttons/action.button';
import AddSkillItemNurse from '@src/components/modals/addSkillItemNurse';
import EditSkillItemNurse from '@src/components/modals/editSkillItemNurse';
import { useAuth } from '@src/contexts/authContext';

const url = `${process.env.REACT_APP_API_URL}/admin/skill-items`;

export default function SkillsItemNurse() {
  const { auth } = useAuth();

  const [loading, setLoading] = useState();
  const [skill, setSkill] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState();
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);

  const fetchData = () => {
    setLoading(true);
    axios
      .get(`${url}`, {
        headers: {
          Authorization: `Bearer ${auth.idToken}`,
        },
      })
      .then((response) => {
        setSkill(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteStatus]);

  const handleDelete = async (id) => {
    try {
      const response = await axios.delete(`${url}/${id}`, {
        headers: {
          Authorization: `Bearer ${auth.idToken}`,
          'My-Custom-Header': 'foobar',
        },
      });

      if (response.status === 200) {
        console.log(response);
        setDeleteStatus('Delete successful');
        setShowDeleteSuccess(true);
        toast.success('Item deleted successfully', {
          position: 'top-center',
          autoClose: 2000,
        });
      } else {
        console.error('Delete operation failed');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const showDeleteConfirmationDialog = (id) => {
    setDeleteId(id);
    setShowDeleteConfirmation(true);
  };

  const handleConfirmationDialogClose = () => {
    setShowDeleteConfirmation(false);
  };

  const handleConfirmationDialogConfirm = () => {
    handleDelete(deleteId);
    setShowDeleteConfirmation(false);
  };

  const [openModal, setOpenModal] = useState(false);
  const showModal = () => {
    setOpenModal(true);
  };

  const [openModals, setOpenModals] = useState(false);
  const showModals = (itemId) => {
    setOpenModals(itemId);
  };

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredList = skill.filter((row) => {
    return row?.item.toLowerCase().includes(searchQuery.toLowerCase());
  });

  return (
    <div>
      <div className='py-4'>
        <Box sx={{ width: '100%' }} className='flex justify-between px-3 py-2'>
          <TextField
            fullWidth
            size='medium'
            variant='outlined'
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                backgroundColor: 'white',
                height: '50px',
              },
              mt: '5px',
              width: '250px',
            }}
            onChange={handleSearch}
            placeholder='Search by name of item'
          />
          <ButtonAction
            onNavigate={() => {
              showModal();
            }}
            label='Add New Item'
          />
        </Box>
        {loading ? (
          <div className='font-poppins py-6 px-8 text-gray-500'>Loading...</div>
        ) : (
          <span className='flex flex-col items-start py-4'>
            <TableContainer
              className='rounded-xl'
              component={Paper}
              style={{
                width: '100%',
                paddingBottom: '12px',
                paddingRight: '12px',
                backgroundColor: '#ffffff',
                borderColor: 'ffffff',
              }}
            >
              <Table
                sx={{
                  minWidth: 350,
                  backgroundColor: '#ffffff',
                  borderColor: 'ffffff',
                }}
                aria-label='simple table'
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      className='text-xs font-bold text-gray-400'
                      style={{
                        width: '200px',
                        border: 'gray',
                        paddingLeft: 30,
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      className='text-xs font-bold text-gray-400'
                      style={{ padding: 4, width: '100px', border: 'gray' }}
                    >
                      Roles
                    </TableCell>

                    <TableCell
                      className='text-xs font-bold text-gray-400'
                      style={{ padding: 4, width: '100px', border: 'gray' }}
                    >
                      Is Deleted
                    </TableCell>

                    <TableCell
                      className='text-xs font-bold text-gray-400'
                      style={{ padding: 4, width: '100px', border: 'gray' }}
                    >
                      Actions
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(filteredList) && filteredList.length > 0 ? (
                    filteredList
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((row) => (
                        <TableRow
                          key={row?._id}
                          hover
                          tabIndex={-1}
                          sx={{
                            '&:last-child td, &:last-child th': { border: 0 },
                          }}
                        >
                          <TableCell
                            component='th'
                            scope='row'
                            style={{ margin: 2, paddingLeft: 30 }}
                            className='text-sm font-bold text-gray-500'
                          >
                            {row?.item || '-'}
                          </TableCell>
                          <TableCell
                            className='text-sm font-bold text-gray-500'
                            style={{ padding: 4 }}
                          >
                            {Array.isArray(row?.roles)
                              ? row.roles
                                  .map((r) => {
                                    const formatted = r
                                      .replace(/_/g, ' ')
                                      .toLowerCase();
                                    return (
                                      formatted.charAt(0).toUpperCase() +
                                      formatted.slice(1)
                                    );
                                  })
                                  .join(', ')
                              : (() => {
                                  const formatted = (row?.roles || '-')
                                    .replace(/_/g, ' ')
                                    .toLowerCase();
                                  return (
                                    formatted.charAt(0).toUpperCase() +
                                    formatted.slice(1)
                                  );
                                })()}
                          </TableCell>

                          <TableCell
                            className=' text-sm font-bold text-gray-500'
                            style={{ padding: 4, margin: 2 }}
                          >
                            {row?.is_deleted ? 'true' : 'false' || '-'}
                          </TableCell>

                          <TableCell style={{ padding: 4, margin: 2 }}>
                            <div className='flex justify-start '>
                              <EditButton
                                onClick={() => showModals(row?._id)}
                              />
                              &nbsp; &nbsp;
                              <DeleteButton
                                onClick={() =>
                                  showDeleteConfirmationDialog(row?._id)
                                }
                              />
                            </div>
                            {showDeleteConfirmation && (
                              <Dialog
                                open={showDeleteConfirmation}
                                onClose={handleConfirmationDialogClose}
                              >
                                <DialogTitle>Confirm Delete</DialogTitle>
                                <DialogContent>
                                  <DialogContentText>
                                    <div>
                                      Are you sure you want to delete this item?
                                    </div>
                                    <div>Please also delete on Preference!</div>
                                  </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    onClick={handleConfirmationDialogClose}
                                    color='primary'
                                  >
                                    Cancel
                                  </Button>
                                  <Button
                                    onClick={handleConfirmationDialogConfirm}
                                    color='error'
                                  >
                                    Delete
                                  </Button>
                                </DialogActions>
                              </Dialog>
                            )}
                          </TableCell>
                        </TableRow>
                      ))
                  ) : (
                    <TableRow>
                      <TableCell
                        className='border border-white'
                        colSpan={6}
                        align='center'
                      >
                        <div className='font-poppins py-6 text-gray-500'>
                          No data
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
              <Box
                className='flex justify-end py-3'
                sx={{ width: '100%', fontFamily: 'Poppins' }}
              >
                <TablePagination
                  rowsPerPageOptions={[10, 50, 100]}
                  component='div'
                  count={skill.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            </TableContainer>
          </span>
        )}
      </div>

      <AddSkillItemNurse
        setOpenModal={setOpenModal}
        showModal={showModal}
        openModal={openModal}
        fetchData={fetchData}
      />

      <EditSkillItemNurse
        setOpenModals={setOpenModals}
        showModals={showModals}
        openModals={openModals}
        fetchData={fetchData}
      />
      <br />
      <br />
      <br />
    </div>
  );
}
